import { IInitialState } from "../Interfaces";

export const initialState: IInitialState = {
  pendingApprovalsList: [],
  pendingApprovalsListLoading: false,
};
